import React from 'react';
import BopisOption from './bopis-option';
import BossOption from './boss-option';

function PickupOption({
  selected,
  select=()=>{},
  details,
  fulfillmentDetails
}) {

  let bossEligible = fulfillmentDetails && fulfillmentDetails.bossEligible;
  return details.type==="BOPIS" ?
    <BopisOption
      details={details}
      select={select}
      selected={selected}
      fulfillmentDetails={fulfillmentDetails}
    /> : <BossOption
      details={details}
      select={select}
      selected={selected}
      bossEligible ={bossEligible}
    />;
}

export default PickupOption;
